<template>
  <div class="modal fade backdrop-blur-sm" :class="name">
    <div class="modal-dialog !pointer-events-auto" :class="dialogClass">
      <FaIcon
        v-if="closable"
        type="fal"
        icon="times"
        class="absolute -right-7 -top-4 z-10 cursor-pointer text-2xl text-slate-100"
        data-bs-dismiss="modal"
      />
      <div class="modal-content overflow-hidden">
        <slot :modal="modal"></slot>
      </div>
      <slot name="bottom-addon"></slot>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap'

export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    dialogClass: {
      type: [String, Object, Array],
      default: ''
    },
    closable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modal: null
    }
  },
  // Open modal when clicking on a link with data-open-<modal-name>="true"
  // Used mainly for: data-open-picture-upload-modal and  data-open-login-signup-modal
  mounted() {
    const modalEl = document.querySelector(`.${this.name}`)
    this.modal = new Modal(modalEl)

    const eventName = `open-${this.name}`

    // Check if a listener is already applied to avoid double listeners by checking property on document.modalsListeners
    if (!document.modalsListeners) document.modalsListeners = {}
    if (document.modalsListeners[eventName]) {
      console.error(`Listeners already applied for modal ${this.name} modal`)
      return
    }

    const listeners = {}

    listeners.clickListener = event => {
      const link = event.target.closest(`*[data-open-${this.name}="true"]`)
      if (link) {
        event.preventDefault()
        this.modal.show()
        this.$emit('open', link)
      }
    }
    listeners.customListener = event => {
      event.preventDefault()
      this.modal.show()
      this.$emit('open', event.detail.target)
    }
    listeners.closeListener = event => this.$emit('close', event)

    document.addEventListener('click', listeners.clickListener)
    document.addEventListener(eventName, listeners.customListener)
    modalEl.addEventListener('hidden.bs.modal', listeners.closeListener)
    document.modalsListeners[eventName] = listeners
  },
  unmounted() {
    const eventName = `open-${this.name}`
    this.modal.dispose()
    document.removeEventListener('click', document.modalsListeners[eventName].clickListener)
    document.removeEventListener(eventName, document.modalsListeners[eventName].customListener)
    document.removeEventListener('hidden.bs.modal', document.modalsListeners[eventName].closeListener)
    delete document.modalsListeners[eventName]
  }
}
</script>
